/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLoanInsuranceCommand
 */
export interface UpdateLoanInsuranceCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanInsuranceCommand
     */
    borrowerId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanInsuranceCommand
     */
    loanAmount: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanInsuranceCommand
     */
    totalDuration: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanInsuranceCommand
     */
    interestRateTypeId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanInsuranceCommand
     */
    interestRatePercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanInsuranceCommand
     */
    loanTypeId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanInsuranceCommand
     */
    defermentPeriod?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanInsuranceCommand
     */
    defermentTypeId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanInsuranceCommand
     */
    insuranceAmount?: number;
}

/**
 * Check if a given object implements the UpdateLoanInsuranceCommand interface.
 */
export function instanceOfUpdateLoanInsuranceCommand(value: object): value is UpdateLoanInsuranceCommand {
    if (!('borrowerId' in value) || value['borrowerId'] === undefined) return false;
    if (!('loanAmount' in value) || value['loanAmount'] === undefined) return false;
    if (!('totalDuration' in value) || value['totalDuration'] === undefined) return false;
    return true;
}

export function UpdateLoanInsuranceCommandFromJSON(json: any): UpdateLoanInsuranceCommand {
    return UpdateLoanInsuranceCommandFromJSONTyped(json, false);
}

export function UpdateLoanInsuranceCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLoanInsuranceCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'borrowerId': json['borrowerId'],
        'loanAmount': json['loanAmount'],
        'totalDuration': json['totalDuration'],
        'interestRateTypeId': json['interestRateTypeId'] == null ? undefined : json['interestRateTypeId'],
        'interestRatePercentage': json['interestRatePercentage'] == null ? undefined : json['interestRatePercentage'],
        'loanTypeId': json['loanTypeId'] == null ? undefined : json['loanTypeId'],
        'defermentPeriod': json['defermentPeriod'] == null ? undefined : json['defermentPeriod'],
        'defermentTypeId': json['defermentTypeId'] == null ? undefined : json['defermentTypeId'],
        'insuranceAmount': json['insuranceAmount'] == null ? undefined : json['insuranceAmount'],
    };
}

export function UpdateLoanInsuranceCommandToJSON(json: any): UpdateLoanInsuranceCommand {
    return UpdateLoanInsuranceCommandToJSONTyped(json, false);
}

export function UpdateLoanInsuranceCommandToJSONTyped(value?: UpdateLoanInsuranceCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'borrowerId': value['borrowerId'],
        'loanAmount': value['loanAmount'],
        'totalDuration': value['totalDuration'],
        'interestRateTypeId': value['interestRateTypeId'],
        'interestRatePercentage': value['interestRatePercentage'],
        'loanTypeId': value['loanTypeId'],
        'defermentPeriod': value['defermentPeriod'],
        'defermentTypeId': value['defermentTypeId'],
        'insuranceAmount': value['insuranceAmount'],
    };
}

